export default __webpack_public_path__ + "static/media/beep.1a7e9a34.mp3";